import { defineComponent as _defineComponent } from 'vue'
import { mdiPlus } from '@mdi/js'

import { UserRole } from '@/modules/Organizations/types'

interface IProps {
  userRole: UserRole
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsAddUser',
  props: {
    userRole: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, mdiPlus }
}

})